function obterRespostaByArray(array, chave) {
  const item = array.find(element => element.label === chave);
  
  return item ? item.resposta : "";
}

export default obterRespostaByArray;
